

























































import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = camelizeKeys(require('./pcl5.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
      items1Til20: factory.scanRange(1, 20),
      durationItem: factory.item('durationItem'),
      severityItem: factory.item('severityItem'),
    }
  },
})
